import { render, staticRenderFns } from "./CompareHeadlineCanvas.vue?vue&type=template&id=bed9045e&"
import script from "./CompareHeadlineCanvas.vue?vue&type=script&lang=js&"
export * from "./CompareHeadlineCanvas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports